import React from 'react';
import Pinpoints from '../components/Pinpoints';

export default function HomeMaintenance() {
  return (
    <main className='am-container home-maintenance-page'>
      <section className='hm-hero'>
        <div className='hm-content'>
          <h1 className='hm-title'>
            Did you know that proactive home maintenance can reduce repair costs by up to 30% and prevent 75% of
            unexpected system failures?
          </h1>
          <p className='hm-lead'>
            At AM Facilities, we're here to help you protect your home and save money with our comprehensive maintenance
            inspections.
          </p>

          <h2 className='hm-sub'>Why Schedule a Maintenance Inspection?</h2>

          <Pinpoints
            className='hm-list'
            iconClass='hm-badge'
            itemTag='div'
            items={[
              <>
                <strong>Save Money:</strong> Address small issues early and avoid costly repairs—up to $4,000 on average
                for major system failures.
              </>,
              <>
                <strong>Extend Lifespan:</strong> Proper maintenance can increase the lifespan of your home’s systems by
                10–15 years.
              </>,
              <>
                <strong>Enhance Safety:</strong> Ensure your electrical, plumbing, and HVAC systems operate efficiently
                and securely.
              </>,
              <>
                <strong>Increase Value:</strong> Well-maintained homes sell for up to 20% more than neglected homes.
              </>,
            ]}
          />

          <p className='hm-cta-lead'>
            Schedule your inspection with AM Facilities today and enjoy peace of mind knowing your home is in expert
            hands.
          </p>

          <div className='hm-actions'>
            <a
              className='am-cta am-cta-primary'
              href='https://app.zenmaid.com/book/a-m-facilities'
              target='_blank'
              rel='noreferrer noopener'
            >
              What are you waiting for, let's chat today!
            </a>
          </div>

          <div className='hm-back'>
            <a href='/' className='hm-back-link'>
              Click here and go back to the main services.
            </a>
          </div>
        </div>

        <aside className='hm-aside'>
          <img src='/assets/home_inspection.avif' alt='Home inspection' />
        </aside>
      </section>
    </main>
  );
}
